import React, { FC } from 'react'

interface Props {}

const NotificationDot: FC<Props> = () => {
  return <div className="h-[10px] w-[10px] rounded-full bg-super-ya-yellow"></div>
}

export default NotificationDot
